<template lang="pug">
.crowd-content
  .crowd-wrap
    .crowd-header
      .crowd-item-back(v-show="currentCrowdType != 'list'",
          @click="goBackToList"
        )
        span.icon
          i.fa.fa-undo
        span 返回上级列表
      .crowd-item-add(v-show="currentCrowdType == 'list'",
          @click="addCrowd"
        )
        span.icon
          i.fa.fa-plus-circle
        span 新建人群
      .crowd-detail(@click="gotoDetail")
        span.icon
          i.fa.fa-cog
        span 查看设置中心

    .crowd-box
      .crowd-sidebar
        ul
          li(v-for="item in crowdGroupTabs",
            :class="{'active': currentCrowdTab == item.key}",
            @click="changeCrowdTab(item.key)"
          )
            span {{item.title}}
            span.right
              i.fa.fa-angle-right
      .crowd-section
        .list
          CrowdTemplate(
              v-if="currentCrowdType != 'list'",
              :noscroll="noscroll",
              :crowd="crowd",
              :type="currentCrowdType",
              @validate="submit"
            )
          ul(v-if="currentCrowdType == 'list'")
            li(v-show="currentCrowd.length == 0"
              style="text-align: center"
            )
              | 暂无人群
            li(v-for="item in currentCrowd",
              :style="item.style",
              v-show="currentCrowd.length > 0",
              :class="{'not-allowed': crowdTags.length >= 5 && !item.checked}"
            )
              label
                v-checkbox(
                    v-model="item.checked",
                    :disabled="crowdTags.length >= 5 && !item.checked",
                    @change.native="updateCrowdTag(item)"
                  )
                span {{item.name}}
              .opt-box
                span(@click="showCrowd(item)"
                  v-show="item.sys_flag == 1")
                  i.fa.fa-eye
                  | 查看
                span(@click="editCrowd(item)",
                    v-show="item.sys_flag==0"
                  )
                  i.fa.fa-pencil-square-o
                  | 编辑
                span(@click="copyCrowd(item)")
                  i.fa.fa-clone
                  | 复制
                span(@click="removeCrowd(item)",
                    v-show="item.sys_flag==0"
                  )
                  i.fa.fa-trash-o
                  | 删除

        .list-footer
          div(v-if="currentCrowdType == 'list'")
            button.btn.btn-primary.btn-small(@click="applyCrowd") 应用
            button.btn.btn-default.btn-small(@click="resetCrowd") 取消
          div(v-else-if="currentCrowdType != 'show'")
            button.btn.btn-primary(@click="submitValid") 保存当前设置


</template>
<script>
/* global _ */
import Store from '../../store/store.js'
import CrowdMixin from '../crowdmixin'
import CrowdTemplate from '../../component/crowdTemplate.vue'
export default {
  store: Store,
  components: {
    CrowdTemplate
  },
  mixins: [CrowdMixin],
  props: {
    crowShowType: String,
    crowdList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      defaultColors: [
        { background: '#EFFAED',
          color: '#4CA63A'
        }, { background: '#EDF4FA',
          color: '#2D70B3'
        }, {
          background: '#FAF4F2',
          color: '#E56D45'
        }, {
          background: '#FAF7FF',
          color: '#6B47B3'
        }, {
          background: '#FFFCF7',
          color: '#FFAA00'
        }
      ],
      unUsedColors: [
        { background: '#EFFAED',
          color: '#4CA63A'
        }, { background: '#EDF4FA',
          color: '#2D70B3'
        }, {
          background: '#FAF4F2',
          color: '#E56D45'
        }, {
          background: '#FAF7FF',
          color: '#6B47B3'
        }, {
          background: '#FFFCF7',
          color: '#FFAA00'
        }
      ],
      noscroll: true,
      currentCrowdType: 'list',
      previewTab: 'system',
      currentCrowdTab: 'system',
      crowd: {}
    }
  },
  created () {
    this.currentCrowdType = this.crowdShowType ? this.crowdShowType : 'list'
  },
  computed: {
    startValidCrowdForm () {
      return this.$store.state.startValidCrowdForm
    },
    crowdApi () {
      return this.currentCrowdType === 'add' ? '/api/crowd/add' : '/api/crowd/edit'
    },
    crowdTags () {
      return _.filter(this.crowdList, {
        checked: true
      })
    },
    currentCrowd () {
      const sysFlag = this.currentCrowdTab === 'system' ? 1 : 0
      return _.filter(this.crowdList, {
        'sys_flag': sysFlag
      })
    },
    crowdGroupTabs () {
      const listObj = {
        'list': [
          {
            key: 'system',
            title: '系统默认'
          }, {
            key: 'custom',
            title: '自定义人群'
          }
        ],
        'add': [
          {
            key: 'add',
            title: '设置新建人群'
          }
        ],
        'edit': [
          {
            key: 'edit',
            title: '设置编辑人群'
          }
        ],
        'show': [
          {
            key: 'show',
            title: '查看人群信息'
          }
        ]
      }
      return listObj[this.currentCrowdType]
    }
  },
  watch: {
    crowdGroupTabs () {
      if (this.currentCrowdType === 'list') {
        this.currentCrowdTab = this.previewTab
      } else {
        this.currentCrowdTab = this.crowdGroupTabs[0].key
      }
    },
    crowdTags (newVal, oldVal) {
      const defaultC = _.cloneDeep(this.defaultColors)
      const usedC = _.map(newVal, 'style')
      const unUsedC = []
      _.map(defaultC, item => {
        if (!_.find(usedC, item)) {
          unUsedC.push(item)
        }
      })
      this.unUsedColors = unUsedC
    }
  },
  methods: {
    submitValid () {
      this.$store.dispatch('SET_START_CROWDVALID', true)
    },
    updateCrowdTag (crowd) {
      const maxCrowdNum = 5
      if (crowd.checked && this.crowdTags.length > maxCrowdNum) {
        this.$set(crowd, 'checked', false)
      }
      if (crowd.checked) {
        this.$set(crowd, 'style', this.unUsedColors[0])
        this.unUsedColors.splice(0, 1)
      } else if (_.has(crowd, 'style') && !_.isEmpty(crowd.style)) {
        this.unUsedColors.push(crowd.style)
        this.$set(crowd, 'style', {})
      }
    },
    applyCrowd () {
      this.crowdShow = false
      this.$emit('apply')
    },
    resetCrowd () {
      this.crowdShow = false
      this.$emit('reset')
    },
    updatePage (pn) {
      this.$emit('upadatePage', pn)
    },
    submit (props) {
      // upload info
      const params = {
        domainId: this.$store.state.domainId,
        name: props.name,
        attr_calc: props.attr_calc,
        attr_rule: JSON.stringify(props.attr_rule),
        action_rule: JSON.stringify(props.action_rule),
        action_calc: props.action_calc
      }
      if (this.currentCrowdType === 'edit') {
        params.clusterid = props.id
      }
      const submitPromise = this.$http.post(this.crowdApi, params, {
        emulateJSON: true
      })
      this.$store.dispatch('VUE_HTTP', [submitPromise])
        .then(res => {
          if (!res.errno) {
            this.goBackToList()
            this.$emit('updateCrowdList')
          }
        })
    },
    gotoDetail () {
      this.$router.push('/setting/crowdSegmentation')
    },
    goBackToList () {
      this.currentCrowdType = 'list'
    },
    changeCrowdTab (tab) {
      this.currentCrowdTab = tab
    },
    parseJSON (rule) {
      const canParse = _.isNull(rule) || rule === ''
      return canParse ? [] : JSON.parse(rule)
    },
    showCrowd (item) {
      this.currentCrowdType = 'show'
      this.previewTab = this.currentCrowdTab
      this.crowd = {
        name: item.name,
        attr_rule: this.parseJSON(item.attr_rule),
        attr_calc: item.attr_calc,
        action_rule: this.parseJSON(item.action_rule),
        action_calc: item.action_calc
      }
    },
    addCrowd () {
      // goback to custom
      this.previewTab = 'custom'
      this.currentCrowdType = 'add'
      this.crowd = {
        name: '',
        attr_calc: 1,
        attr_rule: [],
        action_rule: [],
        action_calc: 1
      }
    },
    editCrowd (item) {
      this.previewTab = this.currentCrowdTab
      this.currentCrowdType = 'edit'
      this.crowd = {
        name: item.name,
        id: item.id,
        attr_rule: this.parseJSON(item.attr_rule),
        attr_calc: item.attr_calc,
        action_rule: this.parseJSON(item.action_rule),
        action_calc: item.action_calc
      }
    },
    copyCrowd (item) {
      // goback to custom
      this.previewTab = 'custom'
      this.currentCrowdType = 'add'
      this.crowd = {
        name: '',
        attr_rule: this.parseJSON(item.attr_rule),
        attr_calc: item.attr_calc,
        action_rule: this.parseJSON(item.action_rule),
        action_calc: item.action_calc
      }
    },
    removeCrowd (item) {
      const removePromise = this.$http.get('/api/crowd/del', {
        params: {
          domainId: this.$store.state.domainId,
          clusterid: item.id
        }
      })
      this.$Modal.confirm('确定删除?', res => {
        if (!res) return
        this.$store.dispatch('VUE_HTTP', [removePromise])
          .then(res => {
            if (!res.errno) {
              this.$emit('removeUpdate')
            }
          })
      })
    }
  }
}
</script>
<style scoped>
@import '../../css/base/variables.css';
.crowd-content {
    height: 420px;
    border: 1px solid #e5e5e5;
    background: #e6ecf2;
    margin-bottom: 20px;
    padding: 10px;
}
.crowd-wrap {
    background: #fff;
    height: 400px;
}
.crowd-header {
    line-height: 40px;
    border-bottom: 1px solid #e5e5e5;
    padding: 0 15px;
    color: #7d93b3;
    overflow: hidden;
    .icon {
      margin-right: 5px;
      font-size: 14px;
    }
    .crowd-item-add,
    .crowd-item-back {
      float: left;
      cursor: pointer;
    }
    .crowd-detail {
      cursor: pointer;
      float: right;
      margin-right: 5px;
    }
    .crowd-item-add {
      color: #73ace6;
    }
}
.crowd-sidebar {
    float: left;
    width: 180px;
    border-right: 1px solid #e5e5e5;
    height: 358px;
    background: #f5f8fb;
    li {
        line-height: 40px;
        padding-left: 15px;
        cursor: pointer;
        .right {
          float: right;
          margin-right: 10px;
          display: none;
        }
        &.active {
          background: #fff;
          .right {
            display: block;
          }
        }
    }
}
.crowd-section {
  .list {
    height: 310px;
    overflow: auto;
    .crowd-container {
      margin-top: 20px;
    }
    li {
        line-height: 40px;
        border-bottom: 1px solid #e5e5e5;
        color: #2B2F33!important;
        .checkbox {
          margin: 0 10px;
        }
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ced3d9;
      border-radius: 10px;
      border-radius: 30px;
    }
    &::-webkit-scrollbar-track {
      background: #eaeced;
    }
    .form {
      margin-top: 15px;
    }

  }
  .list-footer {
    border-top: 1px solid #e5e5e5;
    height: 50px;
    .btn {
      margin: 10px;
    }
    .btn + .btn {
      margin-left: 0;
    }
  }
  .opt-box {
    float: right;
    margin-right: 5px;
    color: #6b7e99;
    cursor: pointer;
    span {
      margin-right: 10px;
      .fa {
        margin-right: 5px;
      }
    }
  }
}
.not-allowed {
  cursor: not-allowed;
  label {
    color: var(--Slightgrey)!important;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// crowEditTemplate.vue?514045f1